import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ReportRecipientInputFormProperty} from './reportRecipientInputForm.property';

@Component({
  selector: 'app-report-recipient-input-form',
  templateUrl: './report-recipient-input-form.component.html',
})
export class ReportRecipientInputFormComponent implements OnInit, OnChanges {

  @Input() formGroup: UntypedFormGroup;
  @Input() initialValue: ReportRecipientInputFormProperty;
  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
  }
}
